import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconHeartSvg } from "./IconHeartSvg.mjs";
const IconHeart = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconHeartSvg, ...iconProps });
};
export {
  IconHeart
};
